import api from './api';

export async function getUserTickets() {
  const response = await api.get('/getTickets');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function getAllTickets() {
  const response = await api.get('/getAllTickets');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function fetchTicket(ticketId) {
  const response = await api.post('/ticketData', { ticket: ticketId });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function submitTicket(subject, message, captcha) {
  const response = await api.post('/ticketSubmit', { subject, message, captcha });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function replyTicket(ticketId, message) {
  const response = await api.post('/ticketReply', { id: ticketId, message });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function closeTicket(ticketId) {
  const response = await api.post('/ticketClose', { id: ticketId });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}
